import $axios from "@/axios-instance";
import { SnackbarProgrammatic as Snackbar } from "buefy";
import { ref, onMounted } from "@vue/composition-api";

export default function useUsers() {
  const users = ref([]);
  const fetch = async () => {
    try {
      const res = await $axios.get("/users");
      if (res.data.success === false || !res.data.payload) {
        throw new Error("Accessing the serve failed at onMounted in useUsers");
      }
      users.value = res.data.payload;
    } catch (error) {
      Snackbar.open({
        message: "Accessing the server failed.",
        actionText: "Close",
        type: "is-warning",
        indefinite: true,
        position: "is-top"
      });
    }
  };

  onMounted(() => {
    fetch();
  });

  return {
    users,
    fetch
  };
}
